import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fcbd156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "columns mt-5" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "card custom-card-wallet" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "wallet-tab" }
const _hoisted_9 = { class: "container mt-5" }
const _hoisted_10 = { class: "columns" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { class: "card custom-card" }
const _hoisted_13 = {
  class: "card-content",
  role: "radiogroup"
}
const _hoisted_14 = { class: "custom-card-title" }
const _hoisted_15 = { class: "radio radio-title mt-2 mb-2" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "control has-icons-left has-icons-right" }
const _hoisted_19 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "control has-icons-left has-icons-right" }
const _hoisted_22 = ["placeholder", "disabled"]
const _hoisted_23 = { class: "icon is-small is-left" }
const _hoisted_24 = {
  key: 0,
  class: "icon is-small is-right"
}
const _hoisted_25 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_26 = {
  key: 0,
  class: "card-content p-0"
}
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "notification is-warning is-light mb-2" }
const _hoisted_31 = { class: "icon is-small" }
const _hoisted_32 = { class: "radio radio-title mt-2 mb-2" }
const _hoisted_33 = { class: "ml-2" }
const _hoisted_34 = {
  key: 0,
  class: "section-body"
}
const _hoisted_35 = ["onChange"]
const _hoisted_36 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordField = _resolveComponent("PasswordField")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_AuthPref = _resolveComponent("AuthPref")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.getUnconfiguredBackends().length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUnconfiguredBackends(), (backend, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass([{
                      'is-wallet-active': _ctx.form.accountBackend === backend,
                    }, "button is-wallet has-text-weight-medium is-rounded ml-3"]),
                        onClick: ($event: any) => (_ctx.form.accountBackend = backend)
                      }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", _hoisted_8, [
                            _createElementVNode("div", null, _toDisplayString(backend), 1)
                          ])
                        ])
                      ], 10, _hoisted_7))
                    }), 256))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.canImport
                    ? _ctx.$gettext("Create or import my wallet")
                    : _ctx.$gettext("Create my wallet")), 1),
              _createElementVNode("div", {
                class: _normalizeClass({
                  notification: _ctx.canImport && _ctx.walletAction === 'create',
                  'wallet-option': _ctx.canImport,
                })
              }, [
                _createElementVNode("label", _hoisted_15, [
                  (_ctx.canImport)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "radio",
                        name: "walletAction",
                        value: "create",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.walletAction) = $event))
                      }, null, 512)), [
                        [_vModelRadio, _ctx.walletAction]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.canImport)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass([{ 'custom-card-title': !_ctx.canImport }, "ml-2"])
                      }, _toDisplayString(_ctx.$gettext("Create my wallet")), 3))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_Transition, { name: "fold" }, {
                  default: _withCtx(() => [
                    (_ctx.walletAction === 'create')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({ 'section-body': _ctx.canImport })
                        }, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$gettext(
                          "Choose the password for your wallet. It is different " +
                            "from your user account password and is only related to " +
                            "your wallet."
                        )), 1),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_PasswordField, {
                                password: _ctx.form.accountPassword,
                                "onUpdate:password": _cache[1] || (_cache[1] = (x) => (_ctx.form.accountPassword = x)),
                                autocomplete: "new-password",
                                class: _normalizeClass({
                            'is-danger': _ctx.hasError('accountPassword'),
                            'is-success':
                              !_ctx.hasError('accountPassword') &&
                              _ctx.form.accountPassword.length > 1,
                          }),
                                disabled: _ctx.useSimplifiedAuth,
                                "icon-right": 
                            _ctx.hasError('accountPassword')
                              ? 'triangle-exclamation'
                              : null
                          
                              }, null, 8, ["password", "class", "disabled", "icon-right"])
                            ]),
                            (_ctx.hasError('accountPassword'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.errors.accountPassword, (err) => {
                                    return (_openBlock(), _createElementBlock("div", null, _toDisplayString(err), 1))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.createUserAccount && _ctx.createUserAccount(...args)), ["enter"])),
                                class: _normalizeClass(["input", {
                            'is-danger': _ctx.hasError('accountPasswordConfirm'),
                            'is-success':
                              !_ctx.hasError('accountPasswordConfirm') &&
                              _ctx.form.accountPasswordConfirm.length > 1,
                          }]),
                                autocomplete: "new-password",
                                type: "password",
                                placeholder: _ctx.$gettext('Password confirmation'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.accountPasswordConfirm) = $event)),
                                disabled: _ctx.useSimplifiedAuth
                              }, null, 42, _hoisted_22), [
                                [_vModelText, _ctx.form.accountPasswordConfirm]
                              ]),
                              _createElementVNode("span", _hoisted_23, [
                                _createVNode(_component_fa_icon, { icon: "key" })
                              ]),
                              (_ctx.hasError('accountPasswordConfirm'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                    _createVNode(_component_fa_icon, { icon: "triangle-exclamation" })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('accountPasswordConfirm'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.form.errors.accountPasswordConfirm[0]), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.hasFieldErrors)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createVNode(_component_AuthPref, {
                                  handler: _ctx.handler,
                                  requestCredentials: _ctx.requestCredentials,
                                  disabled: _ctx.hasFieldErrors,
                                  onSaveConfig: _ctx.saveSimplifiedAuthPref
                                }, null, 8, ["handler", "requestCredentials", "disabled", "onSaveConfig"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("button", {
                                class: "button is-primary",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createUserAccount())),
                                disabled: _ctx.hasFieldErrors
                              }, _toDisplayString(_ctx.$gettext("Create my wallet")), 9, _hoisted_29)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, [
                              _createVNode(_component_fa_icon, { icon: "triangle-exclamation" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$gettext(
                          "Please note that this password can not be retrieved, " +
                            "so be sure to keep it in a safe and reachable place."
                        )), 1)
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 2),
              (_ctx.canImport)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["wallet-option", { notification: _ctx.walletAction === 'import' }])
                  }, [
                    _createElementVNode("label", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "walletAction",
                        value: "import",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.walletAction) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.walletAction]
                      ]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$gettext("Import an existing wallet")), 1)
                    ]),
                    _createVNode(_Transition, { name: "fold" }, {
                      default: _withCtx(() => [
                        (_ctx.walletAction === 'import' && _ctx.canImport)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurableBackends, (configurableBackend) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: configurableBackend,
                                  class: "mb-3"
                                }, [
                                  _createElementVNode("input", {
                                    class: "fileInput",
                                    type: "file",
                                    onChange: 
                          (e) =>
                            _ctx.registerWalletHandle(e, configurableBackend.backend)
                        ,
                                    style: {"display":"none"}
                                  }, null, 40, _hoisted_35),
                                  _createElementVNode("button", {
                                    class: "button is-primary ml-2 mt-2",
                                    id: "import-wallet",
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
                                    innerHTML: 
                          _ctx.configurableBackends.length > 1
                            ? _ctx.$gettextInterpolate(
                                _ctx.$gettext(
                                  'Upload <b>%{ backendName }</b> wallet file...'
                                ),
                                {
                                  backendName:
                                    configurableBackend.backend.jsonData.type.split(
                                      ':'
                                    )[0],
                                }
                              )
                            : _ctx.$gettext('Upload wallet file...')
                        
                                  }, null, 8, _hoisted_36)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}